/**
 * Exportar conversas (Fase 6 do atendimento WhatsApp nativo): baixar o
 * histórico de UMA conversa por vez em texto simples. Regra PURA (testável
 * sem DOM); o disparo do download (Blob/anchor) é efeito de borda, chamado
 * só pela tela.
 *
 * Decisão de escopo: uma conversa por vez, igual ao resto do atendimento
 * (sem envio em massa / sem operação em lote nas Fases 3–4) — exportar
 * "todas as conversas" ou por período fica para decisão futura do cliente.
 */
import type { ConversationDetail } from "../../../../packages/ui/src/types.js";
import { formatDateTime } from "../format.js";

export function conversationToText(detail: ConversationDetail): string {
  const header = `Conversa ${detail.id} — ${detail.customerName} (${detail.channel})`;
  const lines = detail.messages.map((message) => `[${formatDateTime(message.sentAt)}] ${message.senderLabel}: ${message.text}`);
  return [header, "", ...lines].join("\n");
}

export function conversationExportFilename(detail: ConversationDetail): string {
  return `conversa-${detail.id}.txt`;
}

/** Efeito de borda: dispara o download no navegador. Nunca chamado em teste. */
export function downloadTextFile(filename: string, content: string): void {
  const url = URL.createObjectURL(new Blob([content], { type: "text/plain;charset=utf-8" }));
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  anchor.click();
  URL.revokeObjectURL(url);
}
